module.exports = __webpack_public_path__ + "fonts/iconfont.f3646df0.woff2";